import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
  TableLoader,
} from "../../../components/commons";
import { SearchIcon } from "../../../components/Icon";
import UserViewListngHeader from "../../../components/Scheduling/UserView/UserViewListngHeader";
import Select from "react-select";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { ClientType } from "../../../redux/auth/authTypes";
import UserViewListFilter from "../../../components/Scheduling/UserView/UserViewListFilter";
import UserViewListSorting from "../../../components/Scheduling/UserView/UserViewListSorting";
import SchedulingUserViewListTable from "../../../components/Scheduling/UserView/SchedulingUserViewListTable";
import {
  SCHEDULING_APPROVED_LIST_HEADERS,
  SCHEDULING_USER_LIST_HEADERS,
} from "../../../constant/tableHeadersConstants/schedulingConstants/schedulingListTableHeaders";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import EstimateJobUserView from "./EstimateJobUserView";
import {
  AddSchedulingEstimateAction,
  getSchedulingEmployeeApprovedListAction,
  getSchedulingReEstimateListAction,
  getSchedulingUserViewListAction,
  resetReEstimateDataList,
  resetSchedulingApproveTotalCount,
  resetSchedulingApprovedListing,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
  resetSchedulingUserViewListing,
} from "../../../redux/scheduling";
import useDebounce from "../../../customHooks/useDebounce";
import { resetSession } from "../../../redux/auth";
import { Toaster, toast } from "react-hot-toast";
import ApprovedListFilter from "../../../components/Scheduling/UserView/ApprovedListFilter";

export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};

type AppProps = {
  history?: any;
  fetching: boolean;
  employeeApprovedList: any[];
  token: string | null;
  totalCount: number;
  reEstimateDataList: any;
  success: number | null;
  activeTab?: any;
  error: null | string;
  statusCode: number | null;
  message: string | null;
  requestId?: any;
  notificationRedirectId?: string | number | null;
  dispatchGetSchedulingEmployeeApprovedListAction: (data: any) => void;
  dispatchResetSchedulingApprovedList: () => void;
  dispatchResetSession: () => void;
  dispatchResetUserViewError: () => void;
  dispatchResetUserViewSuccess: () => void;
  dispatchResetUserViewMessage: () => void;
  dispatchResetUserViewStatusCode: () => void;
  dispatchResetApprovedTotalCount: () => void;
  dispatchResetReEstimateDataList: () => void;
  dispatchGetReEstimateListAction: (data: any) => void;
  dispatchAddSchedulingEstimateAction: (data: any) => void;
  // clientList: ClientType[] | [];
};
const EstimateApprovedList = ({
  history,
  fetching,
  employeeApprovedList,
  notificationRedirectId,
  token,
  success,
  error,
  statusCode,
  message,
  totalCount,
  activeTab,
  requestId,
  reEstimateDataList,
  dispatchResetReEstimateDataList,
  dispatchResetSession,
  dispatchGetSchedulingEmployeeApprovedListAction,
  dispatchResetSchedulingApprovedList,
  dispatchResetApprovedTotalCount,
  dispatchGetReEstimateListAction,
  dispatchResetUserViewError,
  dispatchResetUserViewMessage,
  dispatchResetUserViewStatusCode,
  dispatchResetUserViewSuccess,
  dispatchAddSchedulingEstimateAction,
}: AppProps) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<any[]>([]);
  const [showSchedulingEstimateModal, setShowSchedulingEstimateModal] =
    useState<boolean>(false);
  const [showSchedulingEstimateData, setShowSchedulingEstimateData] =
    useState<any>(null);
  const [selectedClient, setSelectedClient] = useState<string>("");
  const [jobType, setJobType] = useState<string>("");
  const [jobTypeId, setJobTypeId] = useState("");
  const [searchData, setSearchData] = useState("");
  const [clearSearch, setClearSearch] = useState<boolean>(false);
  const [allSortingValue, setAllSortingValue] = useState("");
  const [sortByStartDate, setSortByStartDate] = useState({
    sort_by: "",
    sort_by_value: "",
  });
  const [filterelected, setFilterelected] = useState<any[]>([]);
  const [targetStartDate, setTargetStartDate] = useState("");
  const [targetEndDate, setTargetEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startDateTo, setStartDateTo] = useState("");

  useEffect(() => {
    dispatchResetSchedulingApprovedList();
    dispatchResetApprovedTotalCount();
    dispatchResetUserViewError();
    dispatchResetUserViewMessage();
    dispatchResetUserViewStatusCode();
    dispatchResetUserViewSuccess();
    if (requestId) {
      let finaData = {
        token,
        id: requestId,
        isPageSeen: true,
        notificationRedirectId,
      };
      dispatchGetReEstimateListAction(finaData);
      setShowSchedulingEstimateModal(!showSchedulingEstimateModal);
    }
  }, []);

  useEffect(() => {
    if (requestId && reEstimateDataList) {
      const data = {
        client_code: reEstimateDataList?.client_code,
        client_name: reEstimateDataList?.client_name,
        future_job: reEstimateDataList?.future_job,
        job_description: reEstimateDataList?.job?.job_description
          ? reEstimateDataList?.job?.job_description
          : reEstimateDataList?.future_job?.job_description,
        job_id: reEstimateDataList?.job?.job_id
          ? reEstimateDataList?.job?.job_id
          : "",
        job_type: reEstimateDataList?.job?.job_type
          ? reEstimateDataList?.job?.job_type
          : reEstimateDataList?.future_job?.job_type,
        period_ended: reEstimateDataList?.job?.period_ended,
        req_id: requestId,
        schedule_status: reEstimateDataList?.schedule_status,
        target_end_date: reEstimateDataList?.job?.target_end_date
          ? reEstimateDataList?.job?.target_end_date
          : reEstimateDataList?.future_job?.target_end_date,
        target_start_date: reEstimateDataList?.job?.target_start_date
          ? reEstimateDataList?.job?.target_start_date
          : reEstimateDataList?.future_job?.target_start_date,
        total_hours: reEstimateDataList?.total_hours,
        updated_at: reEstimateDataList?.target_start_date,
        user_id: reEstimateDataList?.user_id,
      };
      setShowSchedulingEstimateData(data);
    }
  }, [reEstimateDataList]);
  // handleToggleEstimateModal
  const handleToggleEstimateModal = () => {
    setShowSchedulingEstimateModal(!showSchedulingEstimateModal);
  };

  useEffect(() => {
    // dispatchResetTimeSheetReportTotalCount();
    if (token) {
      // if (startDate && endDate) {
      let finalData: any = {
        token,
        limit,
        offset,
        // typeOfJob: jobType,
        // clientCode: selectedClient,
        isApproved: 1,
        sortByStartDate,
        searchData,
        filterTargetStartDate: targetStartDate,
        filterTargetEndDate: targetEndDate,
        filterStartDate: startDate,
        filterStartDateTo: startDateTo,
      };

      if (offset < +totalCount) {
        dispatchGetSchedulingEmployeeApprovedListAction(finalData);
      } else if (offset === 0 && totalCount === 0) {
        dispatchGetSchedulingEmployeeApprovedListAction(finalData);
      }
      // }
    }
  }, [offset]);

  useEffect(() => {
    if (sortByStartDate) {
      if (offset != 0) {
        setOffset(0);
      } else {
        let finalData = {
          token,
          // search_term: searchData,
          searchData,
          limit,
          offset,
          sortByStartDate,
          isApproved: 1,
          filterTargetStartDate: targetStartDate,
          filterTargetEndDate: targetEndDate,
          filterStartDate: startDate,
          filterStartDateTo: startDateTo,

          // typeOfJob: jobType,
          // clientCode: selectedClient,
        };

        if (token) {
          dispatchResetSchedulingApprovedList();
          dispatchGetSchedulingEmployeeApprovedListAction(finalData);
        }
      }
    }
  }, [sortByStartDate?.sort_by, sortByStartDate?.sort_by_value]);

  useEffect(() => {
    if (employeeApprovedList?.length === 0) {
      setData(employeeApprovedList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...employeeApprovedList]);
    } else {
      setData(employeeApprovedList);
    }
  }, [employeeApprovedList]);

  const handleSubmitData = (data: any) => {
    // dispatchResetTimeSheetReportTotalCount();
    // dispatchResetTimeSheetTotalTime();
    setSelectedClient(data?.clientSelected?.value);
    setJobType(data?.jobShow);
    // setCurrentEndDate(data?.endDate)

    window.scrollTo(0, 0);
    setData([]);
    if (token) {
      let finalData: any = {
        token,
        typeOfJob: data?.jobShow,
        clientCode: data?.clientSelected?.value,
        limit,
        offset,
        isApproved: 1,
        searchData,

        // type,
        // ...data,
      };
      if (offset === 0) {
        dispatchGetSchedulingEmployeeApprovedListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  useDebounce(
    () => {
      if (searchData) {
        fetchNewData();
      }
    },
    500,
    [searchData]
  );

  const fetchNewData = () => {
    if (token) {
      setClearSearch(true);
      let finalData = {
        token,
        limit,
        searchData,
        offset,
        sortByStartDate,
        // typeOfJob: jobType,
        // clientCode: selectedClient,
        isApproved: 1,
        filterTargetStartDate: targetStartDate,
        filterTargetEndDate: targetEndDate,
        filterStartDate: startDate,
        filterStartDateTo: startDateTo,
      };
      if (offset === 0) {
        dispatchResetSchedulingApprovedList();
        dispatchGetSchedulingEmployeeApprovedListAction(finalData);
        setOffset(0);
      } else {
        setOffset(0);
      }
    }
  };

  const applyFilter = (data: any) => {
    setFilterelected([
      data?.targetStartDate,
      data?.targetEndDate,
      data?.startDate,
      data?.startDateTo,
    ]);
    let finalData = {
      token,
      limit,
      offset,
      searchData,
      sortByStartDate,
      isApproved: 1,
      // typeOfJob: jobType,
      // clientCode: selectedClient,
      filterTargetStartDate: data?.targetStartDate,
      filterTargetEndDate: data?.targetEndDate,
      filterStartDate: data?.startDate,
      filterStartDateTo: data?.startDateTo,
    };
    if (
      token &&
      (data?.targetStartDate ||
        data?.targetEndDate ||
        data?.startDate ||
        data?.startDateTo)
    ) {
      setOffset(0);
      dispatchResetSchedulingApprovedList();
      dispatchGetSchedulingEmployeeApprovedListAction(finalData);
    }
  };

  const clearFilter = () => {
    setTargetStartDate("");
    setTargetEndDate("");
    setStartDate("");
    setStartDateTo("");
    setFilterelected([]);
    let finalData = {
      token,
      limit,
      offset: 0,
      searchData,
      sortByStartDate,
      isApproved: 1,
      // typeOfJob: jobType,
      // clientCode: selectedClient
    };
    if (token) {
      dispatchResetSchedulingApprovedList();
      dispatchGetSchedulingEmployeeApprovedListAction(finalData);
    }
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);
    if (value?.length === 0) {
      let finalData = {
        token,
        limit,
        offset: 0,
        sortByStartDate,
        filterTargetStartDate: targetStartDate,
        filterTargetEndDate: targetEndDate,
        filterStartDate: startDate,
        filterStartDateTo: startDateTo,
        // typeOfJob: jobType,
        // clientCode: selectedClient,
        isApproved: 1,
      };
      dispatchGetSchedulingEmployeeApprovedListAction(finalData);
    }
  };

  const handleEstimate = (data: any) => {
    dispatchResetReEstimateDataList();
    setShowSchedulingEstimateData(data);
    setShowSchedulingEstimateModal(!showSchedulingEstimateModal);
    setJobTypeId(data?.job_id);
    if (data?.schedule_status === 3) {
      let finaData = {
        token,
        id: data?.req_id,
      };

      dispatchGetReEstimateListAction(finaData);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [employeeApprovedList]);
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (employeeApprovedList?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if
        (error === "The job associated with the provided job_id is Closed." &&
        statusCode === 400
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={"This job has been closed"}
            buttonText="OK"
            onPress={() => {
              dispatchResetUserViewError();
              dispatchResetUserViewMessage();
              dispatchResetUserViewStatusCode();
              dispatchResetUserViewSuccess();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetUserViewError();
            }}
          />
        );
      }
    }
    if (
      success === 1 &&
      message?.includes("and estimates have been updated successfully!")
    ) {
      const finalData = {
        token,
        limit,
        searchData,
        offset: 0,
        isApproved: 1,
        // typeOfJob: jobType,
        // clientCode: selectedClient,
        client_code: selectedClient
          ? selectedClient
          : reEstimateDataList?.client_code,
      };
      if (offset == 0) {
        dispatchGetSchedulingEmployeeApprovedListAction(finalData);
        dispatchResetUserViewSuccess();
        dispatchResetSchedulingApprovedList();
        dispatchResetUserViewMessage();
        toast.success(
          "Scheduling request and estimates have been updated successfully!",
          {
            duration: 2000,
          }
        );
      } else {
        window.scroll(0, 0);
        setOffset(0);
      }
    }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-12 ">
        <div
          className="new-table-card"
          style={{ borderTopRightRadius: "0px", borderTopLeftRadius: "0px" }}
        >
          <div className="header">
            <div className="left-header">
              <div className="heading mb-2"> Approved Estimate List</div>
              <div className="sub-heading mt-0">{`Total ${totalCount ? totalCount : 0
                } entries found`}</div>
            </div>
            <div className="right-header " style={{ marginRight: "-32px" }}>
              <div className="col-md-7 position-relative ">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  style={{ paddingLeft: "35px" }}
                  value={searchData}
                />
              </div>
              {/* </div> */}
              <div className=" mr-1">
                <ApprovedListFilter
                  applyFilter={applyFilter}
                  targetStartDate={targetStartDate}
                  setTargetStartDate={setTargetStartDate}
                  targetEndDate={targetEndDate}
                  setTargetEndDate={setTargetEndDate}
                  clearFilter={clearFilter}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  startDateTo={startDateTo}
                  setStartDateTo={setStartDateTo}
                  filterelected={filterelected}
                  //  filterStatus={filterStatus}
                  //  setFilterStatus={setFilterStatus}
                  selectedClient={selectedClient}
                //  activeTab={activeTab}
                />
              </div>
              <div className="mr-5">
                <UserViewListSorting
                  setSortByStartDate={setSortByStartDate}
                  allSortingValue={allSortingValue}
                  setAllSortingValue={setAllSortingValue}
                />
              </div>
            </div>
          </div>
          {/*  */}
          <div className="col-md-12 p-0 mt-4 mb-4">
            {/* <UserViewListngHeader handleSubmitData={handleSubmitData} /> */}
          </div>

          {fetching && offset === 0 ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : employeeApprovedList?.length > 0 ? (
            <div className="jobsType" style={{ overflowX: "scroll" }}>
              {/* <div className="col-md-12"> */}
              {/* <div className="table-bordered"> */}
              <table className="table table-bordered thead-light">
                <thead className="text-start sticky-table-header">
                  <TableHeader
                    tableHeader={SCHEDULING_APPROVED_LIST_HEADERS}
                  // extraHeader
                  />
                </thead>
                <tbody>
                  <SchedulingUserViewListTable
                    // data={data}
                    handleToggleEstimateModal={handleToggleEstimateModal}
                    handleEstimate={handleEstimate}
                    schedulingUserViewListing={data}
                    tableHeader={SCHEDULING_APPROVED_LIST_HEADERS}
                  />
                  {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                  <div style={{ display: fetching ? "none" : "inline" }}>
                    <ScrollToTop />
                  </div>
                </tbody>
              </table>
              {/* </div> */}
              {/* </div> */}
            </div>
          ) : (
            fetching === false &&
            employeeApprovedList?.length === 0 && (
              <div className="mt-5">
                <EmptyListPage
                  title="No Approved List Found!"
                  imageWidth="30%"
                />
              </div>
            )
          )}
        </div>
      </div>
      <Toaster />
      {handleErrorModal()}
      {showSchedulingEstimateModal && (
        <EstimateJobUserView
          success={success}
          token={token}
          modal={showSchedulingEstimateModal}
          reEstimateDataList={reEstimateDataList}
          toggleModal={handleToggleEstimateModal}
          jobTypeId={jobTypeId}
          selectedClient={selectedClient}
          showSchedulingEstimateModal={showSchedulingEstimateModal}
          showSchedulingEstimateData={showSchedulingEstimateData}
          setShowSchedulingEstimateModal={setShowSchedulingEstimateModal}
          dispatchAddSchedulingEstimateAction={
            dispatchAddSchedulingEstimateAction
          }
          history={history}
          activeTab={activeTab}
        />
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  clientList: state.auth.assignedClientsToUserList,
  fetching: state.scheduling.fetching,
  success: state.scheduling.success,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  message: state.scheduling.message,
  employeeApprovedList: state.scheduling.employeeApprovedList,
  totalCount: state.scheduling.employeeAprrovedTotalCount,
  reEstimateDataList: state.scheduling.reEstimateDataList,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetSchedulingEmployeeApprovedListAction: (data: any) =>
    dispatch(getSchedulingEmployeeApprovedListAction(data)),
  dispatchGetReEstimateListAction: (data: any) =>
    dispatch(getSchedulingReEstimateListAction(data)),
  dispatchResetApprovedTotalCount: () =>
    dispatch(resetSchedulingApproveTotalCount()),
  dispatchResetReEstimateDataList: () => dispatch(resetReEstimateDataList()),
  dispatchResetUserViewSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetUserViewError: () => dispatch(resetSchedulingError()),
  dispatchResetUserViewMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetUserViewStatusCode: () => dispatch(resetSchedulingStatusCode()),
  dispatchResetSchedulingApprovedList: () =>
    dispatch(resetSchedulingApprovedListing()),
  dispatchAddSchedulingEstimateAction: (data: any) => {
    dispatch(AddSchedulingEstimateAction(data));
  },
});
// export default JobsToBeEstimateListing
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EstimateApprovedList);
